import styled from 'styled-components';

import { Row, colors, TagGroup } from '@dexma/ui-components';
import { linkHeaderHeight, linkResponsiveHeaderHeight } from 'adapter/in/dashboards/pages/globalStyles';

export const StyledDashboardLinkHeader = styled(Row)<{ $isLandscape: boolean }>`
    height: ${(props) => (props.$isLandscape ? linkHeaderHeight : linkResponsiveHeaderHeight)};
    padding-left: 24px;
    padding-right: 20px;
    background-color: ${colors.gray100};
    .name {
        color: ${colors.gray800};
        margin: 0;
    }

    .fit {
        flex: 0 0 auto;
    }

    .baseline {
        display: inline-flex;
    }

    .location-name {
        color: ${colors.gray600};
    }
`;

export const StyledTagGroupHeader = styled(TagGroup)`
    display: inline-block;
`;
